import React from "react";

// Contains a KaiChatWidget crash to the widget. Without this, an unhandled render
// error in the assistant unmounts the entire authenticated tenant shell (it is
// mounted in BasePage.js) and the user sees a blank page instead of a broken chat.
// fallback defaults to null on purpose: if KAI fails it should silently disappear.
export default class KaiErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("KAI assistant crashed; widget hidden for this session.", error, info && info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback === undefined ? null : this.props.fallback;
    }
    return this.props.children;
  }
}
